'use client';
import React, { useState, useEffect } from 'react';
import { CollectionsGrid as SharedCollectionsGrid } from '@launchstore/shared-puck';
import type { CollectionsGridProps, SharedCollection } from '@launchstore/shared-puck';
import { listCollections } from '@lib/data/collections';

const SharedRender = (SharedCollectionsGrid as any).render;

const CollectionsGridImpl: React.FC<CollectionsGridProps> = (props: any) => {
  const [collections, setCollections] = useState<SharedCollection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    let active = true;
    async function fetchCollections() {
      setLoading(true);
      setError('');
      try {
        const result = await listCollections();
        const raw: any[] = (result as any)?.collections || [];
        if (!active) return;
        const projected: SharedCollection[] = raw.map((c: any) => ({
          id: c.id,
          title: c.title,
          handle: c.handle,
          image: c.metadata?.image || undefined,
          description: c.description || undefined,
          productCount: c.products?.length ?? 0,
        }));
        setCollections(projected);
      } catch (err: any) {
        if (active) setError(err?.message || 'Failed to fetch collections');
      } finally {
        if (active) setLoading(false);
      }
    }
    fetchCollections();
    return () => { active = false; };
  }, []);

  return <SharedRender {...props} collections={collections} loading={loading} error={error} />;
};

export const CollectionsGrid: any = {
  ...SharedCollectionsGrid,
  render: (props: any) => <CollectionsGridImpl {...props} />,
};
export default CollectionsGrid;
